import { mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue'
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';

export default {
    components: {
        QrcodeVue
    },
    computed: {
        ...mapState('user', {
            userProfile: state => state.userProfile,
            currentUser: state => state.currentUser,
        }),
    },
    methods: {
        convertHtmlToImg() {
            const node = document.getElementById('qrcode-canvas');
            htmlToImage.toPng(node)
                .then(function (dataUrl) {
                    node.remove();
                    const img = new Image();
                    img.src = dataUrl;
                    document.getElementById('qrcode-canvas-generated-image').appendChild(img);
                })
                .catch(function (error) {
                    console.error('oops, something went wrong!', error);
                });
        }
    },
    mounted() {
        setTimeout(this.convertHtmlToImg, 4000)
    }
};


// WEBPACK FOOTER //
// ./src/pages/dashboard/components/overview/dashboard-qr-code/dashboard-qr-code.js